/**
 * Mock data for companies in the SCAD system
 * Centralized data source to be used across all components
 */

export const companiesData = [
  {
    id: 1,
    name: 'TechNova',
    logo: 'https://cdn-icons-png.flaticon.com/512/5968/5968705.png',
    industry: 'Software Development',
    size: '500-1000 employees',
    match: 95,
    description: 'TechNova is a leading software development company specializing in AI and machine learning solutions for enterprise clients. We are committed to innovation and excellence in all our projects.',
    interests: ['Artificial Intelligence', 'Machine Learning', 'Cloud Computing', 'Web Development'],
    recommendations: [
      {
        studentName: 'Ahmed Hassan',
        rating: 4.8,
        comment: 'Great work environment with challenging projects. Learned a lot during my internship.'
      },
      {
        studentName: 'Sara Ahmed',
        rating: 4.5,
        comment: 'Excellent mentorship program and supportive team. Highly recommended for CS students.'
      }
    ]
  },
  {
    id: 2,
    name: 'GlobalFinance',
    logo: 'https://cdn-icons-png.flaticon.com/512/2830/2830284.png',
    industry: 'Financial Services',
    size: '1000+ employees',
    match: 85,
    description: 'GlobalFinance is a multinational financial services company providing innovative solutions in banking, investment, and insurance sectors. We are looking for talented individuals to join our technology team.',
    interests: ['Financial Technology', 'Data Analysis', 'Cybersecurity', 'Blockchain'],
    recommendations: [
      {
        studentName: 'Omar Mahmoud',
        rating: 4.2,
        comment: 'Gained valuable experience in fintech and data analysis. The team was very supportive.'
      }
    ]
  },
  {
    id: 3,
    name: 'EcoSolutions',
    logo: 'https://cdn-icons-png.flaticon.com/512/6001/6001368.png',
    industry: 'Environmental Technology',
    size: '100-500 employees',
    match: 78,
    description: 'EcoSolutions develops sustainable technology solutions for environmental challenges. Our mission is to create innovative products that help businesses reduce their environmental impact.',
    interests: ['Sustainability', 'Clean Energy', 'Environmental Engineering', 'IoT'],
    recommendations: [
      {
        studentName: 'Laila Ibrahim',
        rating: 4.7,
        comment: 'Amazing company culture focused on sustainability. Great projects with real-world impact.'
      },
      {
        studentName: 'Youssef Ali',
        rating: 4.0,
        comment: 'Worked on interesting IoT projects for environmental monitoring. Good learning experience.'
      }
    ]
  },
  {
    id: 4,
    name: 'HealthTech',
    logo: 'https://cdn-icons-png.flaticon.com/512/5360/5360804.png',
    industry: 'Healthcare Technology',
    size: '500-1000 employees',
    match: 92,
    description: 'HealthTech is revolutionizing healthcare through innovative technology solutions. We develop software and hardware products that improve patient care and medical research.',
    interests: ['Medical Informatics', 'Bioinformatics', 'Mobile Health', 'AI in Healthcare'],
    recommendations: [
      {
        studentName: 'Nour Hassan',
        rating: 4.9,
        comment: 'Exceptional internship experience working on AI applications in healthcare. Highly recommended!'
      }
    ]
  },
  {
    id: 5,
    name: 'MediaWorks',
    logo: 'https://cdn-icons-png.flaticon.com/512/5968/5968525.png',
    industry: 'Digital Media',
    size: '100-500 employees',
    match: 75,
    description: 'MediaWorks creates cutting-edge digital media solutions for content creators and publishers. We specialize in interactive experiences, streaming technology, and content management systems.',
    interests: ['Digital Content', 'Streaming Technology', 'UI/UX Design', 'Mobile Development'],
    recommendations: [
      {
        studentName: 'Hana Mohamed',
        rating: 4.3,
        comment: 'Great exposure to the digital media industry. Worked on exciting UI/UX projects.'
      },
      {
        studentName: 'Karim Ahmed',
        rating: 3.9,
        comment: 'Good internship program with opportunities to work on real client projects.'
      }
    ]
  },
  {
    id: 6,
    name: 'InnovateTech',
    logo: 'https://cdn-icons-png.flaticon.com/512/4365/4365271.png',
    industry: 'Technology Consulting',
    size: '500-1000 employees',
    match: 88,
    description: 'InnovateTech provides technology consulting services to businesses across various industries. We help organizations leverage emerging technologies to solve complex business challenges.',
    interests: ['Digital Transformation', 'Cloud Migration', 'Enterprise Architecture', 'Data Strategy'],
    recommendations: [
      {
        studentName: 'Amira Salah',
        rating: 4.6,
        comment: 'Excellent learning environment with exposure to multiple industries and technologies.'
      }
    ]
  }
];

export default companiesData;
